import GLightbox from 'glightbox';

/**
 * ============================================================================
 * WOOCOMMERCE JAVASCRIPT - ORGANIZACJA I FUNKCJE
 * ============================================================================
 * 
 * Ten plik zawiera wszystkie funkcje JavaScript dla WooCommerce
 * Organizacja pliku:
 * 
 * 1. KLASY I KOMPONENTY POMOCNICZE
 * 2. GŁÓWNA APLIKACJA JQUERY
 * 3. OBSŁUGA KOSZYKA I MINI KOSZYKA
 * 4. AJAX DODAWANIE PRODUKTÓW DO KOSZYKA
 * 5. ZAKŁADKI PRODUKTÓW (TABS)
 * 6. WYSZUKIWARKA I NAWIGACJA
 * 7. OCENY I KOMENTARZE
 * 8. SYSTEM ORDER BUMPS
 * 9. SYSTEM KUPONÓW
 * 10. GALERIA PRODUKTÓW
 * 11. INTEGRACJA Z WOOCOMMERCE BLOCKS
 * 
 * Autor: [Twoje dane]
 * Data utworzenia: 2025-11-04
 * Ostatnia modyfikacja: 2025-11-04
 * ============================================================================
 */

/**
 * ============================================================================
 * 1. KLASY I KOMPONENTY POMOCNICZE
 * ============================================================================
 */

/**
 * Klasa obsługi quantity selectors
 * Dodaje przyciski +/- do pól ilości produktów
 * Obsługuje walidację i limity ilości
 */
class wcQuantity {
    constructor() {
        // Konstruktor - obecnie pusty, może być rozszerzony o konfigurację
    }

    /**
     * Inicjalizacja quantity selectors
     * Dodaje przyciski +/- i obsługę eventów
     */
    init() {
        const pQuantity = document.querySelectorAll('.cart .quantity , .product-quantity .quantity');

        if (pQuantity && pQuantity.length > 0) {
            [...pQuantity].forEach((pq) => {
                // Tworzenie przycisków +/-
                const pQUp = document.createElement('span');
                pQUp.classList.add('quanyityUp');
                const pQDown = document.createElement('span');
                pQDown.classList.add('quanyityDown');
                pq.appendChild(pQUp);
                pq.appendChild(pQDown);

                const pQinput = pq.querySelector(':scope .qty');
                let minVal = 1;

                // Specjalna obsługa dla produktów grupowych (min może być 0)
                if (pq.parentElement.classList.contains('woocommerce-grouped-product-list-item__quantity')) {
                    minVal = 0;
                }

                /**
                 * Funkcja zmiany ilości
                 * @param {string} dir - kierunek: 'up' lub 'down'
                 */
                const quentityChange = (dir) => {
                    let newVal = pQinput.value;
                    dir == 'down' ? newVal-- : newVal++;
                    if (newVal <= minVal - 1) newVal = minVal;
                    pQinput.value = newVal;
                    const e = new Event("change", { bubbles: true });
                    pQinput.dispatchEvent(e);
                }

                // Event listeners dla przycisków
                pQUp.addEventListener('click', () => quentityChange('up'));
                pQDown.addEventListener('click', () => quentityChange('down'));

                // Walidacja pola input
                pQinput.addEventListener('change', () => {
                    if (parseFloat(pQinput.value) <= minVal - 1) pQinput.value = minVal;
                    if (parseFloat(pQinput.value) >= parseFloat(pQinput.max)) pQinput.value = pQinput.max;
                    if (parseFloat(pQinput.value) <= parseFloat(pQinput.min)) pQinput.value = pQinput.min;
                });
            });
        }
    }
}

/**
 * ============================================================================
 * 2. GŁÓWNA APLIKACJA JQUERY
 * ============================================================================
 */

(function ($) {
    const mainAppWithJquery = () => {

        /**
         * ============================================================================
         * 2.1 INTEGRACJA Z WOOCOMMERCE BLOCKS CHECKOUT
         * ============================================================================
         */

        /**
         * Konfiguracja filtrów dla WooCommerce Blocks
         * Ukrywa quantity controls dla order bump products
         */
        if (window.wc && window.wc.blocksCheckout) {
            const { registerCheckoutFilters } = window.wc.blocksCheckout;

            const modifyCartItemClass = (defaultValue, extensions, args) => {
                const isCartContext = args?.context === 'cart';

                if (!isCartContext) {
                    return defaultValue;
                }

                const cartItem = args?.cartItem;
                const isBumpProduct = cartItem?.quantity_limits?.maximum === 1 && cartItem?.quantity_limits?.minimum === 1;

                if (isBumpProduct) {
                    return defaultValue + ' hide-quantity';
                }

                return defaultValue;
            };

            registerCheckoutFilters('bump-product-styling', {
                cartItemClass: modifyCartItemClass,
            });
        }

        /**
         * ============================================================================
         * 2.2 INICJALIZACJA KOMPONENTÓW
         * ============================================================================
         */

        // Inicjalizacja quantity selectors
        const quantityWc = new wcQuantity();
        $(document.body).on('updated_wc_div', () => { quantityWc.init() });
        quantityWc.init();

        /**
         * ============================================================================
         * 3. OBSŁUGA KOSZYKA I MINI KOSZYKA...
         * ============================================================================
         */

        /**
         * Aktualizacja zawartości mini koszyka
         * @param {Object} obj - obiekt z fragmentami WooCommerce
         */
        function update_cart(obj) {
            var cartFragment = $(obj['div.widget_shopping_cart_content']);
            $('.shop_mini_cart__cart .widget_shopping_cart_content').html(cartFragment.html());
            $('.topShop__cartTotal, .shop_mini_cart_trigger__cartTotal').html(obj['cartTotal']);
        }

        /**
         * Event: Produkt dodany do koszyka
         * Aktualizuje licznik i pokazuje mini koszyk
         */
        $(document.body).on('added_to_cart', function (e, obj) {
            $('.topShop__cartTotal, .shop_mini_cart_trigger__cartTotal').html(obj['cartTotal']);
            $('.topShop__cartTotal, .shop_mini_cart_trigger__cartTotal').addClass('show');
            update_cart(obj);
            $('body').addClass('showMiniCart');
        });

        /**
         * Event: Produkt usunięty z koszyka
         * Aktualizuje zawartość mini koszyka
         */
        $(document.body).on('removed_from_cart', (e, obj) => {
            update_cart(obj);
        });

        /**
         * Event: Pokazanie mini koszyka
         */
        $(document.body).on('click', '.shop_mini_cart_trigger', function () {
            $('body').addClass('showMiniCart');
        });

        /**
         * Event: Zamknięcie mini koszyka
         */
        $(document.body).on('click', '.shop_mini_cart__close, .shop_mini_cart', function () {
            $('body').removeClass('showMiniCart');
        });

        // Zapobieganie zamknięciu przy kliknięciu w zawartość koszyka
        $(document.body).on('click', '.shop_mini_cart__cart', function (e) {
            e.stopImmediatePropagation();
        });

        /**
         * ============================================================================
         * 3.1 ZMIANA ILOŚCI W MINI KOSZYKU
         * ============================================================================
         */

        /**
         * Funkcja zmiany ilości produktu w mini koszyku
         * @param {Event} e - event object
         * @param {string|number} type - typ zmiany: '+', '-' lub konkretna liczba
         */
        function changeQuantity(e, type) {
            const cart_id = $(e.target).closest('.shop_mini_cart__quantityHolder').attr('data-cart-id');
            let product_quantity = $(e.target).closest('.shop_mini_cart__quantityHolder').attr('data-product-quantity');

            // Oblicz nową ilość
            if (type == '+') {
                product_quantity++;
            } else if (type == '-') {
                product_quantity--;
            } else {
                product_quantity = parseInt(type);
            }

            if (product_quantity < 0) {
                product_quantity = 0;
            }

            const data = {
                action: 'woocommerce_ajax_change_cart_quantity',
                cart_item_key: cart_id,
                quantity: product_quantity
            };

            $.ajax({
                type: 'post',
                url: wc_add_to_cart_params.ajax_url,
                data: data,
                dataType: 'json',
                beforeSend: function () {
                    $(e.target).closest('.shop_mini_cart__quantityHolder').addClass('loading');
                },
                complete: function () {
                    $(e.target).closest('.shop_mini_cart__quantityHolder').removeClass('loading');
                },
                success: function (response) {
                    if (response.error) {
                        console.error('Error updating cart:', response.message);
                    } else {
                        // Aktualizuj fragmenty koszyka
                        if (response.fragments) {
                            $.each(response.fragments, function (key, value) {
                                $(key).replaceWith(value);
                            });
                        }

                        // Aktualizuj wyświetlanie ilości
                        $(e.target).closest('.shop_mini_cart__quantityHolder').attr('data-product-quantity', product_quantity);

                        // Trigger events
                        $(document.body).trigger('updated_cart_totals');
                        $(document.body).trigger('wc_fragment_refresh');
                    }
                },
                error: function (xhr, status, error) {
                    console.error('AJAX Error:', error);
                }
            });
        }

        // Event listeners dla przycisków quantity w mini koszyku
        $(document.body).on('click', '.shop_mini_cart__quantity_plus', function (e) {
            changeQuantity(e, '+');
        });

        $(document.body).on('click', '.shop_mini_cart__quantity_minus', function (e) {
            changeQuantity(e, '-');
        });

        $(document.body).on('change', '.shop_mini_cart__quantity', function (e) {
            changeQuantity(e, e.target.value);
        });

        /**
         * ============================================================================
         * 4. AJAX DODAWANIE PRODUKTÓW DO KOSZYKA
         * ============================================================================
         */

        /**
         * AJAX obsługa dodawania produktów do koszyka na stronie produktu
         * Obsługuje produkty proste, zmienne i z opcjami
         * Fallback do standardowego formularza dla produktów grupowych
         */

        $(document).on('click', '.single_add_to_cart_button', function (e) {
            e.preventDefault();

            // Sprawdź czy AJAX jest dostępny
            if (!wc_add_to_cart_params || $(this).hasClass('disabled')) {

                // Scroll to order summary
                $('html, body').animate({
                    scrollTop: $('.summary').offset().top - 120
                }, 500);
                return true; // Pozwól na standardowe działanie 
            }

            var $form = $(this).closest('form.cart');


            // Sprawdź czy to produkt grupowy - użyj standardowego formularza
            var isGroupedProduct = $form.find('.woocommerce-grouped-product-list').length > 0;
            if (isGroupedProduct) {
                return true;
            }

            // Sprawdź czy to produkt zmienny bez wybranej wariacji
            if ($form.hasClass('variations_form')) {
                var variationId = $form.find('input[name=variation_id]').val();
                if (!variationId || variationId === '0' || variationId === '') {
                    // Scroll to order summary
                    $('html, body').animate({
                        scrollTop: $('.summary').offset().top - 120
                    }, 500);


                    return true; // Pozwól WooCommerce obsłużyć błąd walidacji
                }
            }



            // Zbierz dane z formularza
            var $thisbutton = $(this),
                id = $thisbutton.val() || $thisbutton.attr('data-product_id'),
                product_qty = $form.find('input[name=quantity]').val() || 1,
                product_id = $form.find('input[name=product_id]').val() || id,
                variation_id = $form.find('input[name=variation_id]').val() || 0,
                variation_data = {},
                product_options = $form.parent().find("input[name='product_options[]']:checked").map(function () {
                    return $(this).val();
                }).get().join(',') || null;

            // Zbierz dane wariacji
            $form.find('.variations select').each(function () {
                var attribute_name = $(this).attr('name');
                var attribute_value = $(this).val() || '';
                variation_data[attribute_name] = attribute_value;
            });


            var data = {
                action: 'woocommerce_ajax_add_to_cart',
                product_id: product_id,
                product_sku: '',
                quantity: product_qty,
                variation_id: variation_id,
                product_options: product_options,
                ...variation_data // Dodaj dane wariacji
            };

            $(document.body).trigger('adding_to_cart', [$thisbutton, data]);

            $.ajax({
                type: 'post',
                url: wc_add_to_cart_params.ajax_url,
                data: data,
                dataType: 'json',
                beforeSend: function (response) {
                    $thisbutton.removeClass('added').addClass('loading');
                },
                complete: function (response) {
                    $thisbutton.removeClass('loading');
                },
                success: function (response) {
                    if (response.error) {
                        if (response.product_url) {
                            window.location = response.product_url;
                            return false;
                        } else {
                            if (response.message) {
                                alert(response.message);
                            }
                            $thisbutton.removeClass('added loading');
                            return false;
                        }
                    } else {
                        $thisbutton.addClass('added');

                        // Aktualizuj fragmenty strony
                        if (response.fragments) {
                            $.each(response.fragments, function (key, value) {
                                $(key).replaceWith(value);
                            });
                        }

                        // Trigger event z opóźnieniem
                        setTimeout(() => {
                            $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
                            $(document.body).trigger('wc_fragment_refresh');
                        }, 10);
                    }
                },
                error: function (xhr, status, error) {
                    console.error('AJAX Error:', error);
                    $thisbutton.removeClass('added loading');
                }
            });

            return false;
        });



        const initMobileReserveButton = () => {
            // Sprawdź czy jesteśmy na stronie produktu
            if (!document.body.classList.contains('single-product')) {
                return;
            }

            const summary = document.querySelector('form.cart');
            if (!summary) {
                return;
            }

            // Utwórz przycisk
            const button = document.createElement('button');
            button.className = 'mainBtn mobile-reserve-button';
            button.textContent = 'Kup teraz';
            button.setAttribute('type', 'button');

            // Dodaj przycisk do body
            document.body.appendChild(button);

            // Obsługa kliknięcia - przewiń do .summary
            button.addEventListener('click', () => {

                const targetOffset = jQuery(summary).offset().top - (window.innerHeight - jQuery(summary).outerHeight()) + 100; // Dostosuj offset do wysokości summary
                window.scrollTo({
                    top: targetOffset,
                    behavior: 'smooth'
                });
            });

            // Opcjonalnie: ukryj przycisk gdy summary jest widoczny na ekranie
            if ("IntersectionObserver" in window) {
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            button.classList.add('hidden');
                        } else {
                            button.classList.remove('hidden');
                        }
                    });
                }, {
                    threshold: 0.1
                });
                observer.observe(summary);
            }
        }

        initMobileReserveButton();



        /**
         * ============================================================================
         * 5. ZAKŁADKI PRODUKTÓW (TABS)
         * ============================================================================
         */

        /**
         * Sticky tabs - zakładki które przylepiają się do góry podczas scrollowania
         * Auto-active tabs - automatyczne aktywowanie zakładek na podstawie scrolla
         */
        /*
        const stickyEl = document.querySelector(".wc-tabs");
        if (stickyEl) {
            // Tworzenie elementu do obserwacji sticky
            const stickySpan = document.createElement('span');
            stickySpan.classList.add('wc-tabs-sticky');
            stickyEl.parentNode.insertBefore(stickySpan, stickyEl);

            const topStyle = getComputedStyle(stickyEl).getPropertyValue('top');
            const top = parseFloat(topStyle) || 0;

            // Observer dla sticky behavior
            const observer = new IntersectionObserver(
                ([e]) => stickyEl.classList.toggle('is-sticky', !e.isIntersecting),
                { threshold: [1], rootMargin: `-${top}px 0px 0px 0px` }
            );
            observer.observe(stickySpan);

            // Auto-active tabs observer
            const panels = document.querySelectorAll('.woocommerce-Tabs-panel');
            if (panels.length > 0) {
                const panelObserver = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        const panelId = entry.target.getAttribute('id');
                        const tab = document.querySelector(`.wc-tabs li a[href="#${panelId}"]`);

                        if (entry.isIntersecting) {
                            // Panel się pojawia - ustaw jako aktywny
                            if (tab) {
                                tab.classList.add('active');
                                tab.closest('li').classList.add('active');
                            }
                        } else {
                            // Panel się chowa - usuń active
                            if (tab && tab.classList.contains('active')) {
                                tab.classList.remove('active');
                                tab.closest('li').classList.remove('active');
                            }
                        }
                    });
                }, {
                    rootMargin: `-${top + 50}px 0px -${top + 50}px 0px`,
                    threshold: 0
                });

                panels.forEach(panel => panelObserver.observe(panel));
            }
        }
        */

        /**
         * Wyłączenie domyślnej obsługi tabs WooCommerce
         * Zastąpienie własną implementacją
         */
        /*
           $('body').off('init', '.wc-tabs-wrapper, .woocommerce-tabs');
           $('body').off('click', '.wc-tabs li a, ul.tabs li a');
   
           // Oznacz elementy jako wyłączone z domyślnej inicjalizacji
           $('.wc-tabs-wrapper, .woocommerce-tabs').each(function () {
               $(this).data('wc-tabs-init-disabled', true);
           });
   
           // Przechwytuj i blokuj domyślny event init
           $('body').on('init', '.wc-tabs-wrapper, .woocommerce-tabs', function (e) {
               if ($(this).data('wc-tabs-init-disabled')) {
                   e.stopImmediatePropagation();
                   return false;
               }
           });
   
           // Własna inicjalizacja tabs
           $('body').on('init', '.wc-tabs-wrapper, .woocommerce-tabs', function () {
               $(this).find('.wc-tab, .woocommerce-tabs .panel:not(.panel .panel)').hide();
   
               var hash = window.location.hash;
               var url = window.location.href;
               var $tabs = $(this).find('.wc-tabs, ul.tabs').first();
   
               // Obsługa deep linking do konkretnych zakładek
               if (hash.toLowerCase().indexOf('comment-') >= 0 || hash === '#reviews' || hash === '#tab-reviews') {
                   $tabs.find('li.reviews_tab a').trigger('click');
               } else if (url.indexOf('comment-page-') > 0 || url.indexOf('cpage=') > 0) {
                   $tabs.find('li.reviews_tab a').trigger('click');
               } else if (hash === '#tab-additional_information') {
                   $tabs.find('li.additional_information_tab a').trigger('click');
               }
           });
   
           // Event listener dla kliknięć w zakładki
           $('.wc-tabs li a').on('click', function (e) {
               e.preventDefault();
               const tabId = $(this).attr('href');
               $('.wc-tabs li').removeClass('active');
               $('.wc-tabs li a').removeClass('active');
               $(this).addClass('active');
               $(this).parent().addClass('active');
               $('.woocommerce-Tabs-panel').removeClass('active');
               $(tabId).addClass('active');
           });
   */
        /**
         * ============================================================================
         * 6. WYSZUKIWARKA I NAWIGACJA
         * ============================================================================
         */

        /**
         * Toggle wyszukiwarki w topShop
         */
        $(document.body).on('click', '.topShop__searchTrigger', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            console.log('toggle search - single call');
            $('.topShop__search').toggleClass('show');
            $(this).toggleClass('show');
            return false;
        });
        /**
         * ============================================================================
         * 7. OCENY I KOMENTARZE
         * ============================================================================
         */

        /**
         * Obsługa hover na gwiazdkach ocen
         * Podświetla gwiazdki do pozycji kursora
         */
        $(document).on('mouseenter', '.stars a[role="radio"]', function () {
            $(this).parent().find('a[role="radio"]').removeClass('highlight');
            $(this).addClass('highlight');
            $(this).prevAll().addClass('highlight');
        });

        $(document).on('mouseleave', '.stars a[role="radio"]', function () {
            var activeStars = $(this).parent().find('a[role="radio"].active');
            if (activeStars.length > 0) {
                activeStars.addClass('highlight');
                activeStars.nextAll().removeClass('highlight');
            } else {
                $(this).parent().find('a[role="radio"]').removeClass('highlight');
            }
        });

        /**
         * Toggle formularza komentarzy/recenzji
         */
        $('.showReviewForm, #cancel-comment-reply-link').click(function (e) {
            e.preventDefault();
            $('#review_form_wrapper').toggleClass('show');
            return false;
        });

        /**
         * Walidacja formularza komentarzy
         * Sprawdza czy pole komentarza nie jest puste
         */
        $('#commentform').submit(function (e) {
            const commentField = $(this).find('#comment');
            if (commentField.val().trim() === '') {
                commentField.addClass('wpcf7-not-valid');
                return false;
            } else {
                return true;
            }
        });

        /**
         * ============================================================================
         * 8. SYSTEM ORDER BUMPS
         * ============================================================================
         */

        /**
         * Obsługa dodawania order bump products do koszyka
         * Używa specjalnego AJAX endpoint dla bump products
         */
        jQuery(document).ready(function ($) {
            $('.add-to-cart_bumped-product').on('click', function (e) {
                $('.order-bumps-section').addClass('loading');
                e.preventDefault();
                const productId = $(this).data('product_id');

                $.ajax({
                    url: wc_bump_product.wc_ajax_url.replace('%%endpoint%%', 'add_bump_product'),
                    type: 'POST',
                    data: {
                        security: wc_bump_product.nonce,
                        product_id: productId
                    },
                    success: function (response) {
                        if (response.success) {
                            refreshWooCommerceBlocks();
                            $('.order-bumps-section').remove();
                        } else {
                            alert(response.data.message);
                        }
                    },
                    error: function () {
                        alert('Błąd połączenia z serwerem.');
                    }
                });
            });
        });

        /**
         * Funkcja odświeżania WooCommerce Blocks po dodaniu order bump
         * Invaliduje cache i wymusza ponowne pobranie danych koszyka
         */
        function refreshWooCommerceBlocks() {
            if (window.wp && window.wp.data) {
                const { dispatch, select } = window.wp.data;
                const storeNames = ['wc/store/cart', 'wc/store-api', 'woocommerce/store-api'];

                storeNames.forEach(storeName => {
                    try {
                        if (select(storeName)) {
                            if (dispatch(storeName).invalidateResolution) {
                                dispatch(storeName).invalidateResolution('getCartData', []);
                            }
                            if (dispatch(storeName).receiveCart) {
                                dispatch(storeName).receiveCart();
                            }
                        }
                    } catch (e) {
                        console.log(`Store ${storeName} not available`);
                    }
                });
            }
        }

        /**
         * ============================================================================
         * 9. SYSTEM KUPONÓW
         * ============================================================================
         */

        /**
         * Funkcja dodawania kuponu
         * @param {string} couponCode - kod kuponu do zastosowania
         */
        function applyCoupon(couponCode) {
            // Sprawdź dostępność parametrów
            if (typeof speed_coupon_params === 'undefined') {
                console.error('speed_coupon_params is not defined');
                showCouponMessage('Błąd konfiguracji skryptu', 'error');
                return;
            }

            if (!couponCode || couponCode.trim() === '') {
                showCouponMessage(speed_coupon_params.enter_coupon, 'error');
                return;
            }

            const data = {
                action: 'speed_apply_coupon',
                coupon_code: couponCode.trim()
            };

            $.ajax({
                type: 'POST',
                url: speed_coupon_params.ajax_url,
                data: data,
                dataType: 'json',
                beforeSend: function () {
                    $('button[name="apply_coupon"]').addClass('loading').prop('disabled', true);
                    $('.coupon-message').remove();
                },
                complete: function () {
                    $('button[name="apply_coupon"]').removeClass('loading').prop('disabled', false);
                },
                success: function (response) {
                    console.log('Apply coupon response:', response);

                    if (response.success || response.fragments) {
                        // Sukces - wyczyść pole i pokaż komunikat
                        $('input[name="coupon_code"]').val('');
                        showCouponMessage(speed_coupon_params.coupon_applied, 'success');

                        // Odśwież fragmenty koszyka
                        const fragments = response.fragments || response;
                        if (fragments) {
                            $.each(fragments, function (key, value) {
                                $(key).replaceWith(value);
                            });
                        }

                        // Trigger events
                        $(document.body).trigger('updated_cart_totals');
                        $(document.body).trigger('wc_fragment_refresh');
                        update_cart(fragments);

                    } else {
                        // Błąd - pokaż komunikat
                        const message = response.data && response.data.message ? response.data.message : speed_coupon_params.apply_error;
                        showCouponMessage(message, 'error');
                    }
                },
                error: function (xhr, status, error) {
                    console.error('AJAX Error:', error);
                    console.error('Response:', xhr.responseText);
                    showCouponMessage(speed_coupon_params.connection_error, 'error');
                }
            });
        }

        /**
         * Funkcja usuwania kuponu
         * @param {string} couponCode - kod kuponu do usunięcia
         */
        function removeCoupon(couponCode) {
            if (typeof speed_coupon_params === 'undefined') {
                console.error('speed_coupon_params is not defined');
                showCouponMessage('Błąd konfiguracji skryptu', 'error');
                return;
            }

            const data = {
                action: 'speed_remove_coupon',
                coupon_code: couponCode
            };

            $.ajax({
                type: 'POST',
                url: speed_coupon_params.ajax_url,
                data: data,
                dataType: 'json',
                beforeSend: function () {
                    $('.remove-coupon[data-coupon="' + couponCode + '"]').addClass('loading').prop('disabled', true);
                    $('.coupon-message').remove();
                },
                complete: function () {
                    $('.remove-coupon[data-coupon="' + couponCode + '"]').removeClass('loading').prop('disabled', false);
                },
                success: function (response) {
                    if (response.success || response.fragments) {
                        showCouponMessage(speed_coupon_params.coupon_removed, 'success');

                        // Odśwież fragmenty koszyka
                        const fragments = response.fragments || response;
                        if (fragments) {
                            $.each(fragments, function (key, value) {
                                $(key).replaceWith(value);
                            });
                        }

                        // Trigger events
                        $(document.body).trigger('updated_cart_totals');
                        $(document.body).trigger('wc_fragment_refresh');
                        update_cart(fragments);

                    } else {
                        const message = response.data && response.data.message ? response.data.message : speed_coupon_params.remove_error;
                        showCouponMessage(message, 'error');
                    }
                },
                error: function (xhr, status, error) {
                    console.error('AJAX Error:', error);
                    showCouponMessage(speed_coupon_params.connection_error, 'error');
                }
            });
        }

        /**
         * Wyświetlanie komunikatów kuponów
         * @param {string} message - treść komunikatu
         * @param {string} type - typ: 'success' lub 'error'
         */
        function showCouponMessage(message, type) {
            $('.coupon-message').remove();
            const messageClass = type === 'success' ? 'success' : 'error';
            const messageHtml = `<div class="coupon-message ${messageClass}">${message}</div>`;
            $('.coupon').after(messageHtml);

            // Automatyczne usunięcie komunikatu po 5 sekundach
            setTimeout(() => {
                $('.coupon-message').fadeOut(300, function () {
                    $(this).remove();
                });
            }, 5000);
        }

        /**
         * ============================================================================
         * 9.1 EVENT LISTENERS DLA KUPONÓW
         * ============================================================================
         */

        // Przycisk "Zastosuj kupon"
        $(document.body).on('click', 'button[name="apply_coupon"]', function (e) {
            e.preventDefault();
            const couponCode = $('input[name="coupon_code"]').val();
            applyCoupon(couponCode);
        });

        // Enter w polu kuponu
        $(document.body).on('keypress', 'input[name="coupon_code"]', function (e) {
            if (e.which === 13) { // Enter key
                e.preventDefault();
                const couponCode = $(this).val();
                applyCoupon(couponCode);
            }
        });

        // Przycisk usuwania kuponu
        $(document.body).on('click', '.remove-coupon', function (e) {
            e.preventDefault();
            const couponCode = $(this).data('coupon');
            removeCoupon(couponCode);
        });



        /** 
         * 
        * ============================================================================
         * 10. Galeria produktów i slidery
         * ============================================================================
         * ...
         */
        // Gallery: auto-scroll thumbnails to keep active one visible
        // FlexSlider creates .flex-control-thumbs dynamically, so we wait for window load
        $(window).on('load', function () {
            const thumbsList = document.querySelector('.woocommerce-product-gallery .flex-control-thumbs');
            if (!thumbsList) return;

            const scrollToActive = () => {
                const activeThumb = thumbsList.querySelector('img.flex-active');
                if (!activeThumb) return;
                const li = activeThumb.closest('li');
                if (!li) return;

                const containerWidth = thumbsList.clientWidth;
                const liLeft = li.offsetLeft;
                const liWidth = li.offsetWidth;
                const targetScroll = liLeft - (containerWidth / 2) + (liWidth / 2);

                thumbsList.scrollTo({ left: Math.max(0, targetScroll), behavior: 'smooth' });
            };

            new MutationObserver(scrollToActive).observe(thumbsList, {
                subtree: true,
                attributes: true,
                attributeFilter: ['class']
            });
        });
        if ($('.gProdList ul.products').length > 0) {
            $('.gProdList ul.products').addClass('slickSliderUi');
            $('.gProdList ul.products').slick({
                infinite: false,
                arrows: true,
                dots: false,
                autoplay: false,
                speed: 500,
                autoplaySpeed: 3000,
                slidesToShow: 4,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 782,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 420,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });
        }

        /**
         * ============================================================================
         * 11. INICJALIZACJA APLIKACJI
         * ============================================================================
         */

        // Aplikacja zostanie uruchomiona po załadowaniu DOM
        // Wszystkie funkcje są już zdefiniowane powyżej

        /**
         * ============================================================================
         * 12. SYSTEM FILTROWANIA PRODUKTÓW
         * ============================================================================
         */

        /**
         * Pobiera bazowy URL sklepu (bez query string i paginacji)
         */
        function wooFilterGetBaseUrl() {
            const url = new URL(window.location.href);
            const cleanPath = url.pathname.replace(/\/page\/\d+\/?$/, '/');
            return url.origin + cleanPath;
        }

        /**
         * Pobiera aktualne parametry filtrów z URL
         */
        function wooFilterGetCurrentParams() {
            return new URLSearchParams(window.location.search);
        }

        /**
         * Buduje nowy URL na podstawie bieżących parametrów + zmian
         * @param {Object} changes - klucz/wartość do ustawienia lub null do usunięcia
         */
        function wooFilterBuildUrl(changes) {
            const params = wooFilterGetCurrentParams();
            params.delete('paged');

            for (const [key, value] of Object.entries(changes)) {
                if (value === null || value === '' || (Array.isArray(value) && value.length === 0)) {
                    params.delete(key);
                } else {
                    params.set(key, Array.isArray(value) ? value.join(',') : value);
                }
            }

            const queryString = params.toString();
            return wooFilterGetBaseUrl() + (queryString ? '?' + queryString : '');
        }

        /**
         * Nawiguje do nowego URL filtrowania
         */
        function wooFilterNavigate(url) {
            window.location.href = url;
        }

        /**
         * Zbiera wszystkie zaznaczone checkboxy z filtrów i buduje obiekt zmian URL
         * @returns {Object} klucz (taxonomy) => wartość (tablica slugów lub null)
         */
        function wooFilterCollectCheckboxes() {
            const changes = {};
            const taxonomies = new Set();

            // Zbieramy wszystkie taksonomie z checkboxów
            $('.wooFilter__checkbox').each(function () {
                taxonomies.add($(this).data('taxonomy'));
            });

            // Dla każdej taksonomii zbieramy zaznaczone wartości
            taxonomies.forEach(function (taxonomy) {
                const checked = [];
                $(`.wooFilter__checkbox[data-taxonomy="${taxonomy}"]:checked`).each(function () {
                    checked.push($(this).val());
                });
                changes[taxonomy] = checked.length ? checked : null;
            });

            return changes;
        }

        // Przycisk "Filtruj" - zbiera checkboxy + wyszukiwarkę i nawiguje
        $(document.body).on('click', '#wooFilterApply', function () {
            const changes = wooFilterCollectCheckboxes();
            const searchVal = $('#wooFilterSearch').val().trim();
            changes['s'] = searchVal || null;
            wooFilterNavigate(wooFilterBuildUrl(changes));
        });

        // Enter w polu wyszukiwania filtra - działa jak kliknięcie "Filtruj"
        $(document.body).on('keypress', '#wooFilterSearch', function (e) {
            if (e.which === 13) {
                e.preventDefault();
                $('#wooFilterApply').trigger('click');
            }
        });

        // Obsługa przycisku "Wyczyść" dla pojedynczej sekcji - odznacza checkboxy bez nawigacji
        $(document.body).on('click', '.wooFilter__clearSection[data-clear-taxonomy]', function (e) {
            e.preventDefault();
            const taxonomy = $(this).data('clear-taxonomy');
            $(`.wooFilter__checkbox[data-taxonomy="${taxonomy}"]`).prop('checked', false);
        });

        // Obsługa przycisku "Wyczyść filtry" - odznacza wszystkie i nawiguje
        $(document.body).on('click', '#wooFilterClearAll', function () {
            const filterParams = ['s', 'product_cat', 'product_brand', 'per_page', 'orderby'];
            const params = wooFilterGetCurrentParams();
            params.forEach(function (value, key) {
                if (key.startsWith('pa_')) {
                    filterParams.push(key);
                }
            });
            const changes = {};
            filterParams.forEach(function (key) { changes[key] = null; });
            wooFilterNavigate(wooFilterBuildUrl(changes));
        });

        // Obsługa dropdownów: per_page i orderby
        $(document.body).on('change', '.wooList__controlSelect', function () {
            const controlKey = $(this).data('control');
            const value = $(this).val();
            wooFilterNavigate(wooFilterBuildUrl({ [controlKey]: value }));
        });

        // Zwijanie/rozwijanie sekcji filtrów z zachowaniem stanu w sessionStorage
        function wooFilterInitCollapsible() {
            $('.wooFilter__section').each(function () {
                const sectionKey = 'wooFilter_' + $(this).data('section');
                if (sessionStorage.getItem(sectionKey) === 'collapsed') {
                    $(this).addClass('is-collapsed');
                    $(this).find('.wooFilter__sectionHeader').attr('aria-expanded', 'false');
                }
            });

            $(document.body).on('click', '.wooFilter__sectionHeader', function () {
                const $section = $(this).closest('.wooFilter__section');
                const isCollapsed = $section.hasClass('is-collapsed');
                const sectionKey = 'wooFilter_' + $section.data('section');

                $section.toggleClass('is-collapsed');
                $(this).attr('aria-expanded', isCollapsed ? 'true' : 'false');

                if (isCollapsed) {
                    sessionStorage.removeItem(sectionKey);
                } else {
                    sessionStorage.setItem(sectionKey, 'collapsed');
                }
            });
        }

        wooFilterInitCollapsible();

        /**
         * ============================================================================
         * 12.1 WALIDACJA NIP FIRMY (BLOKOWY CHECKOUT)
         * ============================================================================
         * Walidacja na blur (opuszczenie pola) + input (czyszczenie błędu przy poprawianiu)
         * Selektory oparte na atrybucie name, bo ID zmienia prefix billing/shipping .....
         * Obsługa zarówno polskiego NIP (10 cyfr, opcjonalnie z PL) z sumą kontrolną, jak i zagranicznych numerów VAT (prefiks kraju + 6-13 znaków)
        */

        const NIP_ERROR_MSG = 'Podany NIP jest nieprawidłowy. Polski NIP to 10 cyfr (np. 1234567890). Dla numerów VAT z innych krajów dodaj prefiks kraju, np. EE100247019, DE123456789, SK1234567890.';

        function validateNip(value) {
            const nip = value.replace(/[\s\-\.]/g, '').toUpperCase();
            if (nip === '') return true; // pole opcjonalne

            // Polski NIP: 10 cyfr (opcjonalnie z prefiksem PL) — suma kontrolna mod 11
            const plMatch = nip.match(/^(?:PL)?(\d{10})$/);
            if (plMatch) {
                const digits = plMatch[1];
                const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
                let sum = 0;
                for (let i = 0; i < 9; i++) {
                    sum += parseInt(digits[i], 10) * weights[i];
                }
                return sum % 11 === parseInt(digits[9], 10);
            }

            // Zagraniczny VAT: prefiks kraju (2 litery) + 6-13 znaków alfanumerycznych
            return /^[A-Z]{2}[A-Z0-9]{6,13}$/.test(nip);
        }

        function showNipError(input, message) {
            clearNipError(input);
            const wrapper = input.closest('.wc-block-components-text-input');
            if (!wrapper) return;
            wrapper.classList.add('has-error');
            input.setAttribute('aria-invalid', 'true');
            const errorDiv = document.createElement('div');
            errorDiv.className = 'wc-block-components-validation-error nip-validation-error';
            errorDiv.setAttribute('role', 'alert');
            errorDiv.innerHTML = `<p>${message}</p>`;
            wrapper.after(errorDiv);
        }

        function clearNipError(input) {
            const wrapper = input.closest('.wc-block-components-text-input');
            if (!wrapper) return;
            wrapper.classList.remove('has-error');
            input.setAttribute('aria-invalid', 'false');
            const existing = wrapper.parentNode.querySelector('.nip-validation-error');
            if (existing) existing.remove();
        }
        // nip validation
        $(document.body).on('blur', 'input[name$="thwcfe-block/nip_firmy"]', function () {
            if (!validateNip(this.value)) {
                showNipError(this, NIP_ERROR_MSG);
            }
        });

        $(document.body).on('input', 'input[name$="thwcfe-block/nip_firmy"]', function () {
            clearNipError(this);
        });

        // Obsługa mobilnego toggle przycisku
        $(document.body).on('click', '.wooFilter__mobileToggle', function () {
            const $filter = $('#wooFilter');
            const $btn = $(this);
            const isOpen = $filter.hasClass('is-open');

            $filter.toggleClass('is-open');
            $btn.attr('aria-expanded', isOpen ? 'false' : 'true');
        });
    };

    // Uruchomienie głównej aplikacji po załadowaniu DOM
    document.addEventListener("DOMContentLoaded", mainAppWithJquery, false);

})(jQuery);

/**
 * ============================================================================
 * KONIEC PLIKU
 * ============================================================================
 * 
 * Wszystkie funkcje JavaScript zostały zorganizowane w logiczne sekcje:
 * 
 * 1. ⚙️  KLASY I KOMPONENTY - wcQuantity dla quantity selectors
 * 2. 🚀 GŁÓWNA APLIKACJA - inicjalizacja i integracja z WooCommerce Blocks
 * 3. 🛒 OBSŁUGA KOSZYKA - mini koszyk, aktualizacje, zmiany ilości
 * 4. ➕ AJAX DODAWANIE - dodawanie produktów bez przeładowania strony
 * 5. 📑 ZAKŁADKI PRODUKTÓW - sticky tabs, auto-active, deep linking
 * 6. 🔍 WYSZUKIWARKA - toggle wyszukiwarki w nawigacji
 * 7. ⭐ OCENY I KOMENTARZE - gwiazdki, formularze recenzji
 * 8. 🎁 ORDER BUMPS - dodawanie produktów polecanych z rabatem
 * 9. 🎫 SYSTEM KUPONÓW - dodawanie/usuwanie kuponów, komunikaty
 * 10. 🖼️ GALERIA PRODUKTÓW - powiększanie i przesuwanie obrazów
 * 11. 🔧 INICJALIZACJA - uruchomienie po załadowaniu DOM
 * 12. 🔍 SYSTEM FILTROWANIA - filtry produktów, checkboxy, sortowanie
 *
 * Dla łatwego odnajdywania funkcji użyj wyszukiwania (Ctrl+F) z frazami:
 * - "KLASY I KOMPONENTY" - wcQuantity, komponenty pomocnicze
 * - "GŁÓWNA APLIKACJA" - inicjalizacja, WooCommerce Blocks
 * - "OBSŁUGA KOSZYKA" - mini koszyk, update_cart, quantity
 * - "AJAX DODAWANIE" - single_add_to_cart_button, AJAX
 * - "ZAKŁADKI PRODUKTÓW" - sticky tabs, wc-tabs
 * - "WYSZUKIWARKA" - topShop__searchTrigger 
 * - "OCENY I KOMENTARZE" - stars, reviews, ratings
 * - "ORDER BUMPS" - add-to-cart_bumped-product, refreshWooCommerceBlocks
 * - "SYSTEM KUPONÓW" - applyCoupon, removeCoupon, showCouponMessage
 * - "INICJALIZACJA" - DOMContentLoaded, mainAppWithJquery
 */